import React, { useEffect } from 'react';

interface RunerGameProps {
  onComplete: (score: number) => void;
}

export default function RunerGame({ onComplete }: RunerGameProps) {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Проверяем, что сообщение от нашей игры
      if (event.data && typeof event.data.score === 'number') {
        onComplete(event.data.score);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onComplete]);

  return (
    <div className="w-full h-full">
      <iframe
        src="/runerGame(moshe)/index.html"  // Путь к вашему HTML-файлу в public/
        className="w-full h-full border-none"
        title="Runer Game"
      />
    </div>
  );
}
